import { render, staticRenderFns } from "./InvestigationResiDetails.vue?vue&type=template&id=569ced94&"
import script from "./InvestigationResiDetails.vue?vue&type=script&lang=js&"
export * from "./InvestigationResiDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VRow})
